module.exports = __webpack_public_path__ + "img/67ne.9b77fce6.svg";